var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c('div',{staticClass:"main-content"},[_c('h2',[_vm._v("測試版")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }